/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";

require("./includes/custom/turnstile");
window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.data("app", () => ({
    isContactModalOpen: false,
    isSuccessModalOpen: false,
    isSearchOpen: false,
    isMenuOpen: false,
    isTimelineModalOpen: false,
    enquiry: "",
    modal_image: null,
    modal_year: null,
    modal_title: null,
    modal_content: null,
    scrolled: false,
    isHomepage: document.body.classList.contains("page-front"),
    setModalData(img, year, title, cont) {
        this.modal_image = img;
        this.modal_year = year;
        this.modal_title = title;
        this.modal_content = cont;
    },
    init() {
        const app = document.getElementById("app");
        app.addEventListener(
            "scroll",
            () => {
                this.scrolled = app.scrollTop > 50;
            },
            { passive: true },
        );

        app.addEventListener("open-success-modal", () => {
            this.isContactModalOpen = false;
            this.isSuccessModalOpen = true;
        });
    },
}));
window.getCookie = getCookie;

Alpine.start();

// import { createApp } from "vue";

// const app = createApp({});

// const files = require.context("./", true, /\.vue$/i);
// files.keys().map((key) => app.component(key.split("/").pop().split(".")[0], files(key).default));
// console.log(files);

// app.mount("#app");

require("lightgallery/dist/js/lightgallery-all");

require("./includes/custom/base");

require("./includes/custom/scripts");

require("./includes/custom/swiper");
require("./includes/custom/csrf");

// ------------------------------------
// Cookie
// ------------------------------------
function removeCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
}

function getCookie(name) {
    return document.cookie
        .split("; ")
        .find((row) => row.startsWith(name + "="))
        ?.split("=")[1];
}

function cookie_banner() {
    const cookies = getCookie("acceptCookies");
    if (cookies === undefined) {
        return true;
    }
}
function cookies_accepted() {
    const cookies = getCookie("acceptCookies");
    return cookies !== "false";
}

document.addEventListener("DOMContentLoaded", () => {
    const banner = document.getElementById("cookieNotice");

    if (cookie_banner()) {
        console.log(banner);
        banner.hidden = false;
    }

    document.getElementById("acceptCookies").addEventListener("click", () => {
        document.cookie = "acceptCookies=true; path=/; max-age=31536000; SameSite=Lax";
        banner.hidden = true;
    });

    document.getElementById("declineCookies").addEventListener("click", () => {
        document.cookie = "acceptCookies=false; path=/; max-age=31536000; SameSite=Lax";
        banner.hidden = true;
        window.location.reload();
    });
});

document.querySelector("#contact_form").addEventListener("submit", function () {
    this.querySelector("button[type=submit]").disabled = true;
});
// ------------------------------------
// Form
// ------------------------------------

document.addEventListener("DOMContentLoaded", () => {
    console.log(getCookie("contact_success"));
    if (cookies_accepted()) {
        loadGoogleAnalytics();
        if (getCookie("contact_success")) {
            gtag("event", "contact_form");
        }
    }
    if (getCookie("contact_success")) {
        const thank_you = document.querySelector("#thank-you");
        if (thank_you) {
            document.querySelector("#thank-you").hidden = false;
        }
        document.getElementById("app").dispatchEvent(new CustomEvent("open-success-modal"));
        removeCookie("contact_success");
    }
});

function loadGoogleAnalytics() {
    const tag = document.querySelector("[name='google-analytics']").content;
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=" + tag;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", tag);
    window.gtag = gtag;
}
